import { useState, useEffect, useRef } from "react";
import { api } from "../api/client";

/**
 * Notification-Glocke (nächste Priorität aus dem Design-Konzept,
 * siehe docs/DESIGN_KONZEPT_UI_MODULE.md). Bewusst als eingebettete
 * Komponente in der Sidebar statt einer eigenen Seite/Route - Prinzip
 * "keine neuen Routen ohne Not".
 */
export default function NotificationGlocke() {
  const [offen, setOffen] = useState(false);
  const [anzahl, setAnzahl] = useState(0);
  const [liste, setListe] = useState([]);
  const ref = useRef(null);

  const anzahlLaden = () => {
    api.getAnzahlUngelesen().then(d => setAnzahl(d.anzahl)).catch(() => {});
  };

  useEffect(() => {
    anzahlLaden();
    const intervall = setInterval(anzahlLaden, 60_000);
    return () => clearInterval(intervall);
  }, []);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOffen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const oeffnen = () => {
    setOffen(o => !o);
    if (!offen) {
      api.getNotifications().then(setListe).catch(() => {});
    }
  };

  const alleGelesen = async () => {
    await api.alleNotificationsGelesen();
    setAnzahl(0);
    setListe(l => l.map(n => ({ ...n, gelesen: true })));
  };

  const einzelnGelesen = async (id) => {
    await api.notificationGelesen(id);
    setListe(l => l.map(n => n.id === id ? { ...n, gelesen: true } : n));
    setAnzahl(a => Math.max(0, a - 1));
  };

  return (
    <div ref={ref} style={{ position: "relative", marginBottom: 10 }}>
      <button
        onClick={oeffnen}
        aria-label="Benachrichtigungen"
        style={{
          background: "transparent", border: "none", cursor: "pointer",
          color: "#ccc", fontSize: 16, display: "flex", alignItems: "center", gap: 6, padding: 0,
        }}
      >
        <span>🔔</span>
        {anzahl > 0 && (
          <span style={{
            background: "var(--red, #cc0000)", color: "#fff", borderRadius: 10,
            fontSize: 10, padding: "1px 6px", fontWeight: 700,
          }}>{anzahl}</span>
        )}
      </button>

      {offen && (
        <div style={{
          position: "absolute", bottom: "100%", left: 0, marginBottom: 8,
          width: 280, maxHeight: 320, overflowY: "auto",
          background: "#fff", borderRadius: 8, boxShadow: "0 4px 16px rgba(0,0,0,0.2)",
          zIndex: 100, color: "#333",
        }}>
          <div style={{ padding: "10px 14px", display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #eee" }}>
            <strong style={{ fontSize: 13 }}>Benachrichtigungen</strong>
            {anzahl > 0 && (
              <button onClick={alleGelesen} style={{ background: "none", border: "none", color: "var(--info)", fontSize: 11, cursor: "pointer" }}>
                Alle als gelesen
              </button>
            )}
          </div>
          {liste.length === 0 && (
            <div style={{ padding: 16, fontSize: 12, color: "#999", textAlign: "center" }}>Keine Benachrichtigungen.</div>
          )}
          {liste.map(n => (
            <div
              key={n.id}
              onClick={() => !n.gelesen && einzelnGelesen(n.id)}
              style={{
                padding: "10px 14px", borderBottom: "1px solid #f5f5f5", cursor: n.gelesen ? "default" : "pointer",
                background: n.gelesen ? "#fff" : "#f0f7ff",
              }}
            >
              <div style={{ fontSize: 12, fontWeight: n.gelesen ? 400 : 600 }}>{n.titel}</div>
              {n.text && <div style={{ fontSize: 11, color: "#666", marginTop: 2 }}>{n.text}</div>}
              <div style={{ fontSize: 10, color: "#aaa", marginTop: 2 }}>
                {n.erstellt_am && new Date(n.erstellt_am).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
